/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Filename_PlaceholderInputs */

const en_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a filename here`)
};

const fr_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir un nom de fichier`)
};

const de_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie hier einen Dateinamen ein.`)
};

const it_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci qui un nome file`)
};

const ru_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите имя файла здесь`)
};

const es_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca un nombre de archivo aquí`)
};

const zh_cn2_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请在此处输入文件名`)
};

const ja_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここにファイル名を入力してください`)
};

const hi_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यहां फ़ाइल का नाम दर्ज करें`)
};

const pt_pt2_markers_filename_placeholder = /** @type {(inputs: Markers_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o nome do arquivo aqui.`)
};

/**
* | output |
* | --- |
* | "Enter a filename here" |
*
* @param {Markers_Filename_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_filename_placeholder = /** @type {((inputs?: Markers_Filename_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Filename_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_filename_placeholder(inputs)
	if (locale === "de") return de_markers_filename_placeholder(inputs)
	if (locale === "it") return it_markers_filename_placeholder(inputs)
	if (locale === "ru") return ru_markers_filename_placeholder(inputs)
	if (locale === "es") return es_markers_filename_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_filename_placeholder(inputs)
	if (locale === "ja") return ja_markers_filename_placeholder(inputs)
	if (locale === "hi") return hi_markers_filename_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_filename_placeholder(inputs)
	return en_markers_filename_placeholder(inputs)
});